// Import react libs
import { Link } from 'react-router-dom';

// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled home wrapper
export const HomeWrapper = styled.main`
    /* Appearance */
    background-color: ${colors.primaryBeige};

    /* Element disposition */
    flex-grow: 1;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    /* Spacing */
    padding: 50px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 10px;

        padding: 10px;
    }
`;

// Wrapper for the product cards
export const CardSection = styled.section`
    /* Content disposition */
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: center;
    gap: 50px;

    /* Size */
    max-width: 1200px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 10px;
    }
`;

// Wrapper for the button
export const ButtonSection = styled.section`
    /* Content disposition */
    display: flex;
    justify-content: flex-end;

    /* Size */
    width: 100%;
    max-width: 1200px;
`;

// Styled porduct card link
export const ProductLink = styled(Link)`
    /* Appearance */
    border-radius: 10px;

    /* Events */
    cursor: pointer;
    &:hover {
        /* Visual effects */
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);
    }
`;

// Styled porduct card link
export const ButtonLink = styled(Link)`
    /* Events */
    cursor: pointer;
`;

// Add Icon
export const Icon = styled.svg`
    /* Appearance */
    fill: ${colors.textWhite};

    filter: brightness(1.2);

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;

    &:hover {
        fill: ${colors.primaryBeige};
    }
`;
